import {CONFIG} from "../../config";
import axios from "axios";

async function GetPedestriansQuery(device_id, from_date, to_date) {
    const location = CONFIG.API_URL + "statistics/pedestrians/" + device_id + "/" + from_date + "/" + to_date;
    const settings = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('bearer-token')}`,
        }
    };

    try {
        return await axios.get(location, settings);
    } catch (e) {
        return e;
    }
}

export default GetPedestriansQuery;